import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UserService } from '@sabstravtech/obtservices/angular';

@Component({
  selector: 'app-invoked-user',
  templateUrl: './invoked-user.component.html',
  styleUrls: ['./invoked-user.component.scss'],
  standalone: false
})
export class InvokedUserComponent {
  @Output() reset = new EventEmitter<void>();
  @Input() searchPage = false;
  constructor(public service: UserService) {}

  clearBobo() {
    this.service.setBobo(null);
    this.reset.emit();
  }
}
